import {
  hintTextStyle,
  removalHeaderStyle,
  removalNumberStyle,
  seriesProblemStyle,
} from '../styles'
import type { ProblemToRemove } from '../types'

interface RemovalHeaderProps {
  problems: ProblemToRemove[]
  seriesName?: string
  canRemove: boolean
}

export function RemovalHeader({
  problems,
  seriesName,
  canRemove,
}: RemovalHeaderProps) {
  if (problems.length === 0) {
    return (
      <div style={removalHeaderStyle}>
        <div style={{ fontWeight: 600, marginBottom: '4px', color: '#b91c1c' }}>
          Remove from Series
        </div>
        <div style={hintTextStyle}>
          Search for problems to remove. Select a problem to lock to its series.
        </div>
      </div>
    )
  }

  const title = `Removing from ${seriesName} (${problems.length} selected)`

  return (
    <div style={removalHeaderStyle}>
      <div style={{ fontWeight: 600, marginBottom: '8px', color: '#b91c1c' }}>
        {title}
      </div>
      {problems.map((p, index) => (
        <div key={`${p.problemId}-${p.seriesId}`} style={seriesProblemStyle}>
          <span style={removalNumberStyle}>{index + 1}</span>
          <span style={{ fontSize: '13px' }}>{p.problemTitle}</span>
        </div>
      ))}
      <div style={hintTextStyle}>
        {canRemove
          ? 'Press ⌘+Enter to remove selected problems'
          : 'Select at least 1 problem to remove'}
      </div>
    </div>
  )
}
